import { useBreakpoint } from '@vivino/js-react-common-ui';
import { useI18N } from '@vivino/js-web-common';
import PropTypes from 'prop-types';
import React from 'react';
import { getTotalTasteReviewsCount } from 'vivino-js/helpers/taste';

import { Col, Row } from 'vivino-ui/components/Grid';

import TasteNotes from './TasteNotes';
import TasteStructure from './TasteStructure';
import styles from './tasteCharacteristics.scss';

const TRANSLATIONS = {
  tasteCharacteristics: 'components.shared.taste_characteristics.taste_characteristics',
  howDoesThisWineTaste: 'components.shared.taste_characteristics.how_does_this_wine_taste',
  averageOfReviews: 'components.shared.taste_characteristics.average_of_count_user_taste_reviews',
};

const TasteCharacteristics = ({ tastes, wineId, wineName, vintageYear }) => {
  const { t } = useI18N();
  const reviewsCount = getTotalTasteReviewsCount(tastes);
  const hasUserTasteReviews = reviewsCount > 0;
  const renderAverageOfReviews = () => {
    return (
      <div data-testid="average-of-reviews" className={styles.averageOfReviews}>
        {t(TRANSLATIONS.averageOfReviews, {
          count: reviewsCount,
          wine_name: wineName,
        })}
      </div>
    );
  };

  const { isMobile } = useBreakpoint();
  return (
    <div className={styles.tasteCharacteristics}>
      <Row>
        <Col>
          <h2>{t(TRANSLATIONS.tasteCharacteristics)}</h2>
          {(!tastes.structure || !tastes.flavor) && hasUserTasteReviews && renderAverageOfReviews()}
        </Col>
      </Row>
      {tastes.structure && (
        <Row>
          <Col desktop={8} tablet={8} mobile={6}>
            <TasteStructure structure={tastes.structure} />
          </Col>
          <Col desktop={4} tablet={4}>
            {!isMobile && hasUserTasteReviews && (
              <div className={styles.userTastes}>
                <div className={styles.howDoesThisWineTaste}>
                  {t(TRANSLATIONS.howDoesThisWineTaste)}
                </div>
                {renderAverageOfReviews()}
              </div>
            )}
          </Col>
        </Row>
      )}
      {tastes.flavor && (
        <TasteNotes notes={tastes.flavor} vintageYear={vintageYear} wineId={wineId} />
      )}
    </div>
  );
};

TasteCharacteristics.propTypes = {
  tastes: PropTypes.object,
  vintageYear: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  wineId: PropTypes.number,
  wineName: PropTypes.string,
};

export default TasteCharacteristics;
